import get from 'lodash/get';
import { addValueToPreconfiguredFilter } from './addValueToPreconfiguredFilter';
import { facetToBoolean, facetArrayToObject } from './facets';
import { pricesToObject } from './pricesToObject';
import { arrayToObject } from './arrayToObject';
import { mileageToObject } from './mileageToObject';

export const getFiltersValuesCars = (
  filters,
  searchParametersFilters,
  filtersConf,
  facets,
  country,
  intl
) => {
  /* we are adding prices that doesn't exist in the preconfigured prices */
  addValueToPreconfiguredFilter(get(searchParametersFilters, 'price_min'), filtersConf.prices);
  addValueToPreconfiguredFilter(get(searchParametersFilters, 'price_max'), filtersConf.prices);

  return {
    ...filters,
    decrease_price: facetToBoolean(facets.decrease_price),
    photos: facetToBoolean(facets.photo),
    prices_min: pricesToObject(filtersConf.prices, intl, country),
    prices_max: pricesToObject(filtersConf.prices, intl, country),
    year_min: arrayToObject(filtersConf.years),
    year_max: arrayToObject(filtersConf.years),
    mileage_min: mileageToObject(filtersConf.mileage, intl),
    mileage_max: mileageToObject(filtersConf.mileage, intl),
    doors_min: arrayToObject([2, 3, 4, 5]),
    doors_max: arrayToObject([2, 3, 4, 5]),
    model: facetArrayToObject(facets.fa_model),
    make: facetArrayToObject(facets.fa_make),
    car_type: facetArrayToObject(facets.fa_car_type),
    transmission: facetArrayToObject(facets.fa_transmission),
    fuel: facetArrayToObject(facets.fa_fuel),
  };
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/getFiltersValuesCars.js